module.exports = __webpack_public_path__ + "static/media/moco.481c8811.jpg";